<template>
  <div class="tw-flex tw-w-full">
    <div>
      <stihl-icon
        class="tw-w-4 tw-h-4 tw-mt-1 tw-mr-2"
        :name="icon"
      />
    </div>
    <div>
      <div>
        <div class="tw-mb-2 tw-font-sans tw-text-lg tw-font-bold">
          {{ title }}
        </div>
        <delivery-type-selector-address
          v-if="enabled"
          :has-located="hasLocated"
          :address="address"
          @setAddress="$emit('setAddress')"
        />
        <div v-else>
          {{ noun }} not available
        </div>
        <div v-if="enabled && hasLocated">
          <div
            v-if="rate && zone"
            class="tw-mb-2"
          >
            <div
              class="tw-font-sans tw-text-sm tw-font-bold"
              data-test="estimated-delivery-fee"
            >
              Estimated {{ noun }}: ${{ rate.fee.toFixed(2) }}
            </div>
            <div
              class="tw-font-sans tw-text-xs tw-font-normal"
              data-test="cart-minimum-message"
            >
              Minimum Cart Total For {{ noun }}: ${{ rate.minimumOrderTotal.toFixed(2) }}
            </div>
          </div>
          <div v-else-if="!rate && !zone">
            <div class="tw-mb-2 tw-text-red">
              {{ dealerName }} does not {{ verb }} to this address.
            </div>
          </div>
          <div v-else-if="!rate && zone">
            <div
              class="tw-font-sans tw-text-sm tw-font-bold"
              data-test="cart-minimum-not-met-message"
            >
              Cart does not meet minimum for {{ noun }}.
            </div>
            <div
              class="tw-font-sans tw-text-xs tw-font-normal"
              data-test="cart-minimum-message"
            >
              Minimum Cart Total For {{ noun }}: ${{ zone.rates[0].minimumOrderTotal.toFixed(2) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>   
</template>
<script>

import StihlIcon from './StihlIcon.vue';
import DeliveryTypeSelectorAddress from './DeliveryTypeSelectorAddress.vue'
export default {
  components: {
    DeliveryTypeSelectorAddress,
    StihlIcon
  },
  props: {
    enabled: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    rate: {
      type: Object,
      default: () => {}
    },
    zone: {
      type: Object,
      default: () => {}
    },
    noun: {
      type: String,
      required: true
    },
    verb: {
      type: String,
      required: true
    },
    dealerName: {
      type: String,
      required: true
    },
    hasLocated: {
      type: Boolean,
      required: true
    },
    address: {
      type: String,
      default: ''      
    }
  }  
}
</script>